<template>
   <el-tabs type="border-card">
        <el-tab-pane label="PC类目编辑">
            <div style="margin-top:16px;" >
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="类目名称">
                        <el-input v-model.trim="form.name" placeholder="类目名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="onSubmit">立即编辑</el-button>
                        <el-button @click="onCancel" size="mini">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
  export default {
    data() {
      return {
        form: {
          name: '',
          token: this.user.getToken()
        },
      }
    },
    methods: {
      onSubmit() {
        // 初始化默认加载菜单
        this.http.post(
          '/firstCategory/editor',
          this.form, res => {
            if (res.success) {
              // 返回正确的处理
              this.$router.push("/firstCategory/list")
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      },
      onCancel() {
          this.$router.go(-1)
      }
    },
    mounted() {
      this.form = this.$route.params
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/views/category/firstCategoryEditor.vue